import { useGameStore, useLocalBubbleId, useRecordingBubbles } from '@campus/core';
import { useIsMobile } from '../hooks/useIsMobile.js';
import { useElapsed } from '../hooks/useElapsed.js';

/**
 * RecordingBanner — bandeau permanent "Enregistrement en cours".
 *
 * Consentement RGPD géré par cette notice visible en permanence (spec design
 * 2026-08-20, section "Cycle de vie" — jamais implémenté avant ce fix) : pas
 * de blocage à l'entrée d'une meeting-room enregistrée, juste une
 * information continue et non-ignorable tant que l'enregistrement dure.
 *
 * Visible UNIQUEMENT pour les joueurs dont la bulle locale (localBubbleId)
 * est dans recordingBubbles — pas toute la zone ouverte, seuls les
 * participants réellement dans la bulle enregistrée (cohérent avec Room
 * Composite Egress, qui ne capture que les membres de cette bulle précise,
 * voir CLAUDE.md section "Room LiveKit dédiée meeting-room").
 */
export function RecordingBanner() {
  const localBubbleId = useLocalBubbleId();
  const recordingBubbles = useRecordingBubbles();
  const isMobile = useIsMobile();
  // Durée : après un rafraîchissement, on voit tout de suite que l'enregistrement continue.
  const startedAt = useGameStore((s) => (localBubbleId ? s.recordingStartedAt.get(localBubbleId) : undefined));
  const elapsed = useElapsed(startedAt);

  if (!localBubbleId || !recordingBubbles.has(localBubbleId)) return null;

  // Au-dessus de la barre de contrôle, jamais en haut : les vignettes vidéo
  // occupent le haut de l'écran et le cachaient (constaté sur VPS2, 2026-08-24).
  // Placé dans la pile du bas (.pl-stack-bottom, App.tsx), sous les invites.
  return (
    <div
      role="status"
      className="pl-pop"
      style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '8px 14px', borderRadius: isMobile ? 'var(--radius-lg)' : 'var(--radius-full)',
        borderColor: 'var(--color-danger)', fontSize: 13, fontWeight: 500,
        pointerEvents: 'none', whiteSpace: isMobile ? undefined : 'nowrap',
      }}
    >
      <span className="pl-rec-dot" aria-hidden="true" />
      <span>Enregistrement en cours{elapsed && <> · {elapsed}</>}</span>
      {!isMobile && <span style={{ fontSize: 12, fontWeight: 400, color: 'var(--color-text-secondary)' }}>· tout le monde dans la salle est prévenu</span>}
    </div>
  );
}
